/**
 * Helper module to add authorization header to axios requests
 * Place this file in your src/utils/ directory
 */

/**
 * Gets the current authentication token from localStorage
 * @returns {string|null} The authentication token or null if not found
 */
export const getAuthToken = () => {
    return localStorage.getItem('accessToken');
};

/**
 * Creates authentication headers for API requests
 * @returns {Object} Headers object with Authorization if token exists
 */
export const getAuthHeaders = () => {
    const token = getAuthToken();
    return token
        ? { 'Authorization': `Bearer ${token}` }
        : {};
};

/**
 * Checks if user is currently authenticated (has a token)
 * @returns {boolean} True if authenticated, false otherwise
 */
export const isAuthenticated = () => {
    return !!getAuthToken();
};

/**
 * Attach auth headers to any config object
 * @param {Object} config - The config object to add headers to
 * @returns {Object} Updated config with auth headers
 */
export const withAuth = (config = {}) => {
    const headers = getAuthHeaders();
    return {
        ...config,
        headers: {
            ...config.headers,
            ...headers
        }
    };
};